export default "__VITE_ASSET__CxkLppk___"